import { request } from '@umijs/max';
// import { config } from '@/utils/config';
// import qs from 'qs';

/**
 *
 * @param data 获取banner
 * @returns
 */
export const getBannerList = async (params?: any) => {
  return request('/api/community/owner/WechatBanner/page', {
    method: 'get',
    params,
  });
};

/**
 * 获取资讯
 *
 */
export const getWechatNewsList = async (params?: any) => {
  return request('/api/community/owner/WechatNews/page', {
    method: 'get',
    params,
  });
};

/**
 * 获取活动
 */

export const getWechatActivityList = async (params?: any) => {
  return request('/api/community/owner/WechatActivity/page', {
    method: 'get',
    params,
  });
};

/**
 * 获取移动端用户详情
 */

export const queryAccountInfo = async () => {
  return request(`/api/community/owner/WechatOwner/getInfo`);
};

/**
 * 获取资讯详情
 */

export const detailWechatNews = async (params: any) => {
  return request(`/api/community/owner/WechatNews/read`, {
    method: 'get',
    params,
  });
};

/**
 * 获取活动详情
 */

export const detailWechatActivity = async (params: any) => {
  return request(`/api/community/owner/WechatActivity/read`, {
    method: 'get',
    params,
  });
};

/**
 * 报名接口
 */

export const signupWechatActivity = async (data: any) => {
  return request(`/api/community/owner/WechatActivity/signup`, {
    method: 'post',
    data,
  });
};

/**
 * 通知公告接口
 */

export const getWechatNotice = async (params: any) => {
  return request(`/api/community/owner/WechatNotice/page`, {
    method: 'get',
    params,
  });
};

/**
 * 通知公告详情
 */

export const detailWechatNotice = async (params: any) => {
  return request(`/api/community/owner/WechatNotice/read`, {
    method: 'get',
    params,
  });
};

/**
 * 问卷调查 
 */
export const getWechatQuestionnaire = async (params: any) => {
  return request(`/api/community/owner/WechatQuestionnaire/wx/page`, {
    method: 'get',
    params,
  });
};

/**
 * 问卷调查详情
 */

export const detailWechatQuestionnaire = async (sequenceNbr: any) => {
  return request(`/api/community/owner/WechatQuestionnaire/${sequenceNbr}`);
};

/**
 * 答题
 */

export const submitWechatRespondents = async (data: any) => {
  return request(`/api/community/owner/WechatRespondents`, {
    method: 'post',
    data
  });
};

/**
 * 查看答卷
 */

export const viewWechatRespondents = async (params: any) => {
  return request(`/api/community/owner/WechatRespondents`, {
    method: 'get',
    params
  });
};


/**
 * 投票列表
 */

export const getWechatVote = async (params: any) => {
  return request(`/api/community/owner/WechatVote/wx/page`, {
    method: 'get',
    params
  });
};

/**
 * 投票详情
 */

export const detailWechatVote = async (sequenceNbr: any) => {
  return request(`/api/community/owner/WechatVote/${sequenceNbr}`, {
    method: 'get'
  });
};

/**
 * 投票
 */

export const submitWechatVote = async (data: any) => {
  return request(`/api/community/owner/WechatVote/vote`, {
    method: 'post',
    data
  });
};

/**
 * 投票结果详情
 */

export const resultWechatVote = async (params: any) => {
  return request(`/api/community/owner/WechatVote/vote/detail`, {
    method: 'get',
    params
  });
};

/**
 * 电话列表​/community​/owner​/WechatPhone​/page
 */
 export const getWechatPhone = async (params: any) => {
  return request(`/api/community/owner/WechatPhone/page`, {
    method: 'get',
    params
  });
};

/**
 * 管家 
 */
export const getWechatFloorButler = async (params: any) => {
  return request(`/api/community/base/WechatFloorButler/page`, {
    method: 'get',
    params
  });
};

/**
 * 协议community/wechat/WechatAgreement/findByType/
 */

export const getWechatAgreement = async (type: any) => {
  return request(`/api/community/wechat/WechatAgreement/findByType/${type}`, {
    method: 'get',
  });
};

/**
 * 留言提交接口
 */
export const submitWechatMessage = async (data: any) => {
  return request(`/api/community/wechat/WechatMessage`, {
    method: 'post',
    data
  });
};

/**
 * 关于物业
 */

export const getWechatAboutPage = async (params: any) => {
  return request(`/api/community/owner/WechatAbout/page`, {
    method: 'get',
    params
  });
};

/**
 * 预览查看物业
 * 
 */

export const viewWechatAboutPage = async (params: any) => {
  return request(`/api/community/owner/WechatAbout/read`, {
    method: 'get',
    params
  });
};

/**
 * 办事指南列表
 */

export const getWechatGuide= async (params: any) => {
  return request(`/api/community/owner/WechatGuide/wx/page`, {
    method: 'get',
    params
  });
};

/**
 * 办事指南详情
 * 
 */

export const viewWechatGuide = async (params: any) => {
  return request(`/api/community/owner/WechatGuide/read`, {
    method: 'get',
    params
  });
};
